module.exports = __webpack_public_path__ + "img/bull_lol4.c082bd67.png";